//1x png
import customers_1x_1_png from './customers/customers@1x-1.png';
import customers_1x_2_png from './customers/customers@1x-2.png';
import customers_1x_3_png from './customers/customers@1x-3.png';
//1x webp
import customers_1x_1_webp from './customers/customers@1x-1.webp';
import customers_1x_2_webp from './customers/customers@1x-2.webp';
import customers_1x_3_webp from './customers/customers@1x-3.webp';
//2x png
import customers_2x_1_png from './customers/customers@2x-1.png';
import customers_2x_2_png from './customers/customers@2x-2.png';
import customers_2x_3_png from './customers/customers@2x-3.png';
//2x webp
import customers_2x_1_webp from './customers/customers@2x-1.webp';
import customers_2x_2_webp from './customers/customers@2x-2.webp';
import customers_2x_3_webp from './customers/customers@2x-3.webp';

export const images = {
  customers_1x_1_png,
  customers_1x_1_webp,
  customers_2x_1_png,
  customers_2x_1_webp,
  customers_1x_2_png,
  customers_1x_2_webp,
  customers_2x_2_png,
  customers_2x_2_webp,
  customers_1x_3_png,
  customers_1x_3_webp,
  customers_2x_3_png,
  customers_2x_3_webp,
};
